export const timeZone = "Asia/Seoul";

export const emptyClusterText =
  "There's no zone. Please create your zone first.";
